export class TypeEtablissement {
    constructor(
        public id?: number,
        public code?: string,
        public libelle?: string,
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/type-etablissement.model.ts